
<template>
    
    <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
        <span>{{name}}</span>
    </div>
        <div class="text item paramContainer">
            <el-row :gutter="10">
                <el-col class="paramNameCol" :span="8">
                    CSS
                </el-col>
                <el-col :span="16">
                    <el-input
                        placeholder="Please input URI(s)"
                        v-model="selectors"
                        type="textarea"
                        clearable>
                    </el-input>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    xPATH
                </el-col>
                <el-col :span="16">
                    <el-input
                        placeholder="Input region (text)"
                        type="textarea"
                        v-model="xpaths"
                        clearable>
                    </el-input> 
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Target
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.target"  placeholder="Select mode">
                        <el-option
                        v-for="item in target"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Validation
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.validation"  placeholder="Validation mode">
                        <el-option
                        v-for="item in validation"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Required
                </el-col>
                <el-col :span="16">
                    <el-checkbox class="clickCheckbox" v-model="model.params.required"></el-checkbox>        
                </el-col>
            </el-row>
            <el-row>
                <div class="tip">
                    Choose how to find element for a click, specify the validation action.
                </div>
            </el-row>
        </div>
    </el-card>    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'Element Presence',
    props: {
        key: {
            type: Number
        },
        editedId: {
            type: Number
        },
        model: {
            type: Object,
            default: () => {}
        },
    },

    data () {
        return {
            name:'Click',
            validation: ['none','click','redirect'],
            selectors: this.prepareParam(this, 'selector'),
            xpaths: this.prepareParam(this, 'xpath'),
            id: this.editedId,
            target: [ 
                {value:'specified_by_user', name: 'Specified by user'},
                {value:'random_internal_link', name: 'Random internal name'},
            ],
        }
    },

    methods: {
        
    },
    computed: {
        ...mapState('bot', {
        bot: 'bot',
        project: 'project',
        error: 'error',
        loading: 'loading',
        }),
    },
    watch: {
        selectors(newValue, oldValue) {
            this.model.params.selector = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        xpaths(newValue, oldValue) {
            this.model.params.xpath = newValue.replace(/\r\n/g,"\n").split("\n");
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .clickCheckbox {
        margin-top: 10px;
    }
</style>
